module.exports = __webpack_public_path__ + "static/media/Party Face Emoji.I01.2k.71484a32.png";